import configDev from 'config.dev'
import configProd from 'config.prod'

const configBase = {
  apiKey: 'AIzaSyBf3NhajsRVihk3qjBz5fDhIdl9fHwh-5E',
  authDomain: 'photoalbum-cbdfe.firebaseapp.com',
  databaseURL: 'https://photoalbum-cbdfe.firebaseio.com',
  projectId: 'photoalbum-cbdfe',

  adminUids: [ '9krfKhsp4cOboEiR7ziGGqwnl982', 'UMV03XD8yKg5RMrTf1amXlqV5bG3' ],
}
const configExtended = process.env.NODE_ENV === 'production' ? configProd : configDev

export default Object.assign({}, configBase, configExtended)

export interface Config {
  apiKey: string
  authDomain: string
  databaseURL: string
  projectId: string
  photoCollection: string

  adminUids: string[]

  Cloudinary: CloudinaryConfig
}

interface CloudinaryConfig {
  UploadPreset: string
}



// WEBPACK FOOTER //
// ./src/config.ts